import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ ...params }) => {
  return await dponetAPI.get('/churns', { params })
}

const show = async ({ churnId }) => {
  return await dponetAPI.get(`/churns/${churnId}`)
}

const create = async ({ ...data }) => {
  return await dponetAPI.post(`/churns`, {
    churn: data,
  })
}

const update = async ({ churnId, params }) => {
  return await dponetAPI.put(`/churns/${churnId}`, params)
}

const changeContract = async ({ churnId, ...params }) => {
  return await dponetAPI.put(`/churns/${churnId}/change_contract`, params)
}

const overduePayment = async ({ churnId, ...params }) => {
  return await dponetAPI.get(`/churns/${churnId}/overdue_payment`, { params })
}

const listResponsibles = async () => {
  return await dponetAPI.get('responsibles_by_churn')
}

const availablePreRegistrations = async ({ paymentContractId }) => {
  return await dponetAPI.get('churns_available_pre_registrations', {
    params: { paymentContractId },
  })
}

const destroy = async ({ churnId }) => {
  return await dponetAPI.delete(`/churns/${churnId}`)
}

const cancel = async ({ churnId }) => {
  return await dponetAPI.patch(`/churns/${churnId}/cancel`)
}

const churns = {
  get,
  show,
  create,
  update,
  changeContract,
  overduePayment,
  listResponsibles,
  availablePreRegistrations,
  destroy,
  cancel,
}

export default churns
